exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.pre-intake--1GaSrADTp1z2PsxeRIahdS {\n  font-size: .875rem;\n  font-weight: 500;\n  color: #42a6cb;\n  line-height: 1.375rem;\n  padding: .25rem;\n  margin: 0 -0.25rem 0 auto;\n}\n\nbutton.pre-intake--1GaSrADTp1z2PsxeRIahdS:hover {\n  color: #447382;\n}\n", ""]);

// exports
exports.locals = {
	"linkButton": "pre-intake--1GaSrADTp1z2PsxeRIahdS",
	"linkButton": "pre-intake--1GaSrADTp1z2PsxeRIahdS"
};